import { useEffect, useState } from "react";

const STORAGE_KEY = "readdy18-age-confirmed";

export default function AgeGate() {
  const [checked, setChecked] = useState(false);
  const [visible, setVisible] = useState(false);
  const [denied, setDenied] = useState(false);

  useEffect(() => {
    let confirmed = false;
    try {
      confirmed = window.localStorage.getItem(STORAGE_KEY) === "true";
    } catch {
      confirmed = false;
    }
    setVisible(!confirmed);
    setChecked(true);
  }, []);

  const accept = () => {
    try {
      window.localStorage.setItem(STORAGE_KEY, "true");
    } catch {
      // ignore
    }
    setVisible(false);
  };

  if (!checked || !visible) return null;

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center bg-primary-950/94 px-4 backdrop-blur-sm">
      <div className="w-full max-w-md animate-fade-up rounded-lg border border-background-50/10 bg-background-50 p-7 md:p-9">
        <div className="mb-6 flex items-center gap-3">
          <span className="flex h-12 w-12 flex-col items-center justify-center rounded-md bg-primary-600 text-background-50">
            <span className="font-heading text-lg font-bold leading-none">18</span>
            <span className="mt-0.5 text-[9px] leading-none tracking-[0.12em]">禁</span>
          </span>
          <div>
            <p className="text-[10px] tracking-[0.2em] text-foreground-500">ADULT ARCHIVE</p>
            <p className="font-heading text-lg font-semibold text-foreground-950">成人内容提示</p>
          </div>
        </div>

        <p className="text-sm leading-relaxed text-foreground-700">
          本站为成人内容资讯与资源介绍平台，内容仅面向 18 岁以上成年人。站内所有作品、人物与数据均为虚构演示，不提供真实资源下载。
        </p>
        <p className="mt-3 text-sm leading-relaxed text-foreground-600">
          进入前请确认您已年满 18 岁，并自愿浏览相关内容。
        </p>

        {denied ? (
          <div className="mt-5 rounded-md border border-primary-200 bg-primary-50 px-4 py-3 text-xs leading-relaxed text-primary-700">
            未满 18 岁的访客请关闭本页面。本站不向未成年人提供任何内容。
          </div>
        ) : null}

        <div className="mt-7 flex flex-col gap-3 sm:flex-row">
          <button
            type="button"
            onClick={accept}
            className="w-full cursor-pointer whitespace-nowrap rounded-md bg-primary-600 px-5 py-3 text-sm font-medium text-background-50 transition hover:bg-primary-700"
          >
            我已满 18 岁，进入
          </button>
          <button
            type="button"
            onClick={() => setDenied(true)}
            className="w-full cursor-pointer whitespace-nowrap rounded-md border border-background-300 px-5 py-3 text-sm font-medium text-foreground-700 transition hover:border-foreground-400"
          >
            我未满 18 岁
          </button>
        </div>

        <p className="mt-5 text-[11px] leading-relaxed text-foreground-500">
          继续浏览即表示您同意本站的内容声明与使用条款。您的选择仅保存在本地浏览器。
        </p>
      </div>
    </div>
  );
}